<template>
  <div class="s_chat_middle_upload">
    <input type="file" @change="fileSelected()" name="s-chat-middle-upload-file" :accept="uploadAccept" id="s-chat-middle-upload-file" style="display:none;">
  </div>
</template>

<script>
import { apiUploadFile } from '@/utils/api'
export default {
  props: {
    // 聊天客户ID
    chatUserId: {
      type: Number,
      default() {
        return 0
      }
    },
    // 1 图片
    // 2 文件
    uploadType: {
      type: Number,
      default() {
        return 0
      }
    },
    uploadAccept: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      uploadItem: { create_time: parseInt(new Date().getTime() / 1000), kefu_name: '', msg: { filePath:'', fileName:'',  fileSize:'' }, send_type: 2, type: 1 },
      imgLimitSize: 1024 * 1024 * 5, //图片限制大小
      fileLimitSize: 1024 * 1024 * 10 //文件限制大小
    }
  },
  methods: {
    // 1. 原有的 input change 监听保持不变
    async fileSelected() {
      if(!document.getElementById('s-chat-middle-upload-file').files.length) return
      let file = document.getElementById('s-chat-middle-upload-file').files[0]

      // 直接调用核心上传方法
      await this.uploadFileByFileObject(file)
    },

    // 2. 新增：核心通用上传方法（可供父组件直接调用）
    async uploadFileByFileObject(file) {
      if (!file) return;

      // 1. 根据文件类型自动修正并匹配 uploadType
      const isImage = file.type.indexOf('image/') !== -1;

      if (isImage) {
        this.$emit('update:uploadType', 1); // 如果父组件支持 .sync 语法可以这样更新，或者让父组件在传入前设定好
        // 针对图片的体积校验
        if (file.size > this.imgLimitSize) {
          return this.$message({ message: '上传的图片太大，不能超过5MB', type: 'warning'});
        }
      } else {
        this.$emit('update:uploadType', 2);
        // 针对文件的体积校验
        if (file.size > this.fileLimitSize) {
          return this.$message({ message: '上传文件太大，不能超过10MB', type: 'warning'});
        }
      }

      // 2. 动态获取当前最终的上传类型（优先以判断出来的类型为准，防止异步 props 延迟）
      const finalUploadType = isImage ? 1 : 2;

      // formdata提交
      var formData = new FormData()
      formData.append('file', file)
      formData.append('type', finalUploadType)
      formData.append('id', this.chatUserId)

      // 触发开始上传进度条展示
      this.$emit('emitStartUpload', file)

      // 开始上传
      const { success, data } = await apiUploadFile(formData).catch(()=> {
        this.$emit('emitFailUpload')
        this.clearInputValue()
        return null
      })

      if(!success) {
        this.$emit('emitFailUpload')
        this.clearInputValue()
        return null
      }

      // 绑定消息类型
      this.uploadItem.type = finalUploadType

      // 将后台传过来的JSON msg 反序列化
      let successMsg = JSON.parse(data.msg)

      // 创建时间
      this.uploadItem.create_time = data.create_time
      this.uploadItem.kefu_name = data.kefu_name

      // 根据最终类型组装数据结构
      if(finalUploadType === 1) {
        this.uploadItem.msg.filePath = successMsg.filePath
      } else {
        this.uploadItem.msg.filePath = successMsg.filePath
        this.uploadItem.msg.fileName = successMsg.fileName || file.name
        this.uploadItem.msg.fileSize = successMsg.fileSize || `${(file.size / 1024).toFixed(2)} KB`
      }

      this.uploadItem.id = data.id
      this.uploadItem.is_read = data.is_read
      // 上传成功触发出去
      this.$emit('emitUploadSuccess', this.uploadItem)

      // 清空 input 状态
      this.clearInputValue()
    },

    // 抽离清空 input 的辅助方法
    clearInputValue() {
      const el = document.getElementById('s-chat-middle-upload-file')
      if (el) el.value = null
    }
  }
}

</script>

<style lang="scss">
</style>